import React from 'react'
import './header.css'
import Typewriter from 'typewriter-effect/dist/core';
import CTA from './CTA'
import Me1 from '../../assets/Me1.png'
import HeaderSocials from './HeaderSocials';
import { useState,useEffect } from 'react';


function Header() {

  return (
    <header>
<div className='container header_container'>
<h5>Hello I'm</h5>
<h1>Aman Kumar</h1>
<h5 className='text-light'>Fullstack Developer</h5>
<CTA/>
<HeaderSocials/>
<div className='me'>
  <img src={Me1} alt='myphoto'/>
</div>
<a href='#contact' className='scroll_down'>Scroll Down</a>
</div>
    </header>
  )
}



export default Header